import axios from "http/customAxios";
import { useEffect, useState } from "react";
import { IConfig, useConfig } from "../../../lib/config";

export const useGetReservations = ({ propertyTicker }: { propertyTicker: string }) => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const configuration: IConfig = useConfig();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // TODO: replace with httpclient
        const { data } = await axios.post(
          `${configuration.apiEndpoint}/api/properties/reservations/list`,
          {
            filters: { status: "OK" },
            page: 0,
            propertyTickers: [propertyTicker],
            size: 6,
          }
        );
        const newData = data?.content?.map((reservation: any) => ({
          multipleBookingId: reservation.multipleBookingId,
          checkin: reservation.checkin,
          checkout: reservation.checkout,
          customer: `${reservation.customer.name} ${reservation.customer.lastName}`,
          status: reservation.status,
          totalAmount: reservation.totalAmount,
        }));
        setData(newData);
      } catch (error) {
        console.log("Error in reservations", error);
      }
      setLoading(false);
    };
    fetchData();
  }, [configuration.apiEndpoint, propertyTicker]);

  return { data, loading };
};
